<template>
  <section id="main-container">
    <v-container fluid>
      <v-layout flex>
        <v-flex xs12 style="max-width:1020px;margin:0 auto;">
          <div id="centered-content">
            <img
              height="160px"
              style="margin:0 auto; display:block; padding-bottom:40px; "
              slot="activator"
              src="../assets/login-cb-logo.svg"
            />
            <v-layout
              wrap
              row
              &#x26;#x3C;v-layout
              :style="$vuetify.breakpoint.mdAndUp && 'min-height:350px;'"
            >
              <v-flex
                xs12
                md6
                class="login-box pa-4"
                style="border-top-right-radius: 5px;border-bottom-right-radius: 0px; border-bottom-left-radius: 0px;border-top-left-radius: 5px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 0px;border-bottom-right-radius: 0px; border-bottom-left-radius: 5px;border-top-left-radius: 5px;'"
              >
                <v-flex style="display:table; height:100%; width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h1 class="primary--text pb-3">
                      Password reset link
                      sent to your email
                    </h1>
                    <p>
                      We have sent an email to your inputted address. Click the
                      link in this email to reset your password. This link will expire
                      in 30 minutes.
                    </p>
                    <v-form ref="form">
                      <v-flex pt-0>
                        <router-link :to="{ name: 'Login'}">
                          <v-btn block class="ml-0 mb-0 mt-0" color="secondary">Return to login</v-btn>
                        </router-link>
                      </v-flex>
                    </v-form>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex
                xs12
                md6
                class="promo-box pa-4"
                style="border-top-right-radius: 0px;border-bottom-right-radius: 5px; border-bottom-left-radius: 5px;border-top-left-radius: 0px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 5px;border-bottom-right-radius: 5px; border-bottom-left-radius: 0px;border-top-left-radius: 0px;'"
              >
                <v-flex style="display:table; height:100%;width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h2 class="pb-2" style="line-height:1.2em;">
                      Explore the latest new
                      features in Caseblocks
                    </h2>
                    <p>
                      We’ve been busy developing and expanding Caseblocks
                      core functionalilty to make it even better.
                    </p>
                    <v-btn class="ml-0 mt-1" color="secondary" outline>Explore</v-btn>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>

export default {
  name: "ResetConfirmation",
  components: {},
  data: () => {
    return {}
  }
}
</script>
